import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import TitleScreenCrud from '../../../shared/TitleScreenCrud'
import MDInput from '../../../shared/MDInput'
import MDBox from '../../../shared/MDBox'
import MDButton from '../../../shared/MDButton'
import MDTypography from '../../../shared/MDTypography'
import { Button } from '@mui/material'
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded'
import PersonRoundedIcon from '@mui/icons-material/PersonRounded'
import IconEdit from '@mui/icons-material/Edit'
import IconInativa from '@mui/icons-material/PersonRemove'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { Tooltip } from '@material-ui/core'
import { ContainerGoCadastro } from './ProfessoresForm.styled'
import professorService from '../../professorService'
import { IProfessor } from '../../ProfessorType'

export default function ProfessoresForm() {
  const navigate = useNavigate()
  const [professores, setProfessores] = React.useState<IProfessor[]>([])
  const [searchFilter, setSearchFilter] = React.useState('')
  const [professorSelecionado, setProfessorSelecionado] = React.useState<number | null>(null)

  const carregarDados = async () => {
    const result = await professorService.getAll()
    const data = result.data.map(p => ({
      ...p,
      especialidades: typeof p.especialidades === 'string'
        ? (p.especialidades as string).split(',').map((s: string) => s.trim()).filter(Boolean)
        : p.especialidades || []
    }))
    setProfessores(data)
  }

  React.useEffect(() => {
    carregarDados()
  }, [])

  const handleFilterData = (search: string) => {
    if (!search) {
      carregarDados()
      return
    }
    const filtrados = professores.filter(p =>
      p.nome.toLowerCase().includes(search.toLowerCase()) ||
      p.cpf.includes(search) ||
      p.email.toLowerCase().includes(search.toLowerCase())
    )
    setProfessores(filtrados)
  }

  const handleEdit = (id: string) => {
    navigate(`/professores/cadastro?id=${id}`)
  }

  const handleDetalhe = (id: string) => {
    navigate(`/professores/detalhe?id=${id}`)
  }

  const handleInativar = async (id: string) => {
    if (window.confirm('Deseja inativar este professor?')) {
      await professorService.inativar(id)
      carregarDados()
    }
  }

  const customInputStyle = { width: '100%', padding: 26, marginTop: -16 }

  return (
    <TitleScreenCrud title="Professores">
      <MDInput
        style={customInputStyle}
        placeholder="Filtrar por nome, CPF ou email"
        onChange={(event) => {
          setSearchFilter(event.target.value)
          handleFilterData(event.target.value)
        }}
      />
      <MDBox style={{ padding: '0 16px' }}>
        {professores.map((prof, index) => (
          <MDBox
            key={prof.id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            style={{
              padding: '12px 16px',
              borderBottom: '1px solid #e0e0e0',
              background: professorSelecionado === index ? '#f5f5f5' : 'transparent',
              cursor: 'pointer',
            }}
            onClick={() => setProfessorSelecionado(index)}
          >
            <MDBox display="flex" alignItems="center">
              <PersonRoundedIcon style={{ color: prof.ativo ? 'green' : 'red', marginRight: 12 }} />
              <MDBox>
                <MDTypography variant="button" fontWeight="medium">{prof.nome}</MDTypography>
                <MDTypography variant="caption" color="text" style={{ display: 'block' }}>
                  {prof.cpf} | {prof.email} | {prof.telefone}
                </MDTypography>
                <MDTypography variant="caption" color="text">
                  Especialidades: {prof.especialidades.join(', ')}
                </MDTypography>
              </MDBox>
            </MDBox>
            <MDBox display="flex" gap="8px">
              <Tooltip title="Ver anamneses dos alunos" arrow>
                <MDButton color="info" circular size="small" onClick={(e) => { e.stopPropagation(); handleDetalhe(prof.id) }}>
                  <VisibilityIcon />
                </MDButton>
              </Tooltip>
              <Tooltip title="Editar professor" arrow>
                <MDButton color="info" circular size="small" onClick={(e) => { e.stopPropagation(); handleEdit(prof.id) }}>
                  <IconEdit />
                </MDButton>
              </Tooltip>
              <Tooltip title="Inativar professor" arrow>
                <MDButton color="info" circular size="small" onClick={(e) => { e.stopPropagation(); handleInativar(prof.id) }}>
                  <IconInativa />
                </MDButton>
              </Tooltip>
            </MDBox>
          </MDBox>
        ))}
        {professores.length === 0 && (
          <MDBox padding={3} textAlign="center">
            <MDTypography variant="button" color="text">Nenhum professor encontrado.</MDTypography>
          </MDBox>
        )}
      </MDBox>
      <ContainerGoCadastro>
        <Button
          onClick={() => navigate('/professores/cadastro')}
          style={{ width: 50, height: 50, backgroundColor: '#FFF', borderRadius: 50 }}
        >
          <AddCircleRoundedIcon style={{ width: 40, height: 40, color: '#ba79e1' }} />
        </Button>
      </ContainerGoCadastro>
    </TitleScreenCrud>
  )
}
